import { TimetableItemBase } from "./timetableItemBase";
import { TimetableLesson } from "./timetableLesson";

export class TimetableSubstitution extends TimetableItemBase {

   constructor(data, view, weekNumber, dm) {
      super(data);
      this.view = view;
      this.weekNumber = weekNumber;
      this.dm = dm;
      this.onClick = (course) => {};

      //console.log(data);

      Object.assign(this, data);

      //console.log(this);

      /*
      this.lessonRef = data.orig.lessonRef;
      this.newDate = data.orig.changes &&  data.orig.changes.newDate ? this.convertDavinciDate(data.orig.changes.newDate) : false;
      this.oldDate = data.orig.changes &&  data.orig.changes.oldDate ? this.convertDavinciDate(data.orig.changes.oldDate) : false;
      this.newHour = data.orig.changes && data.orig.changes.newHour ? parseInt(data.orig.changes.newHour.slice(0,-1)) : false;
      this.oldHour = data.orig.changes && data.orig.changes.oldHour ? parseInt(data.orig.changes.oldHour.slice(0,-1)) : false;
      this.message = data.info || '';
      */
      
      /*
      // 'new...'-Items in 'changes' verschieben
      for (const prop in data.orig) {
         if (prop.startsWith('new')) {
            data.orig.changes[prop] = data.orig[prop];
            delete data.orig[prop];
         }
      }

      // Wenn ein 'new...' Item in 'changes' vorliegt, wird das entsprechende normale Item zum 'absent...'-Item.
      for (const prop in data.orig.changes) {
         if (prop.startsWith('new')) {
            const baseProp = prop[3].toLowerCase() + prop.slice(4);
            const absentProp = 'absent' + baseProp[0].toUpperCase() + baseProp.slice(1);
            if (data.orig.hasOwnProperty(baseProp) && !data.orig.changes.hasOwnProperty(absentProp)) {
               data.orig.changes[absentProp] = data.orig[baseProp];
            }
         }
      }
      */
      /*
      this.teachers = this.getFirstDefinedProperty([data.orig.changes.newTeacherCodes, data.orig.teacherCodes], []);
      this.rooms    = this.getFirstDefinedProperty([data.orig.changes.newRoomCodes, data.orig.roomCodes], []);
      this.classes  = this.getFirstDefinedProperty([data.orig.changes.newClassCodes, data.orig.classCodes], []);
      this.origClasses = data.orig.classCodes.slice(0)   ;

      this.absentTeachers = this.getFirstDefinedProperty([data.orig.changes.absentTeacherCodes, data.orig.absentTeacherCodes], []);
      this.absentRooms    = this.getFirstDefinedProperty([data.orig.changes.absentRoomCodes, data.orig.absentRoomCodes], []);
      this.absentClasses  = this.getFirstDefinedProperty([data.orig.changes.absentClassCodes, data.orig.absentClassCodes], []);
      this.cancelled = data.orig.changes.hasOwnProperty('cancelled');
      */

      //this.classes = this.classes.map(item => dm.getClassByName(item).id);
      //this.origClasses = this.origClasses.map(item => dm.getClassByName(item).id);
      //this.absentClasses = this.absentClasses.map(item => dm.getClassByName(item).id);

      /*
      if (data.orig.courseTitle) {
         const match = data.orig.courseTitle.match(/^\+(.*) \((.*)\)$/);
         if (match) {
            this.titles = [match[1]];
            this.absentTitles = [match[2]];
         }
      }
      
      if (!this.titles) {
         this.titles = [data.orig.courseTitle];
         if (data.orig.changes.lessonTitle && data.orig.changes.lessonTitle !== this.titles[0]) {
            this.absentTitles = this.titles;
            this.titles = [data.orig.changes.lessonTitle];
         }
         else {
            this.absentTitles = [];
         }
      }
      */

      /*
      // verschobene Stunde
      if (data.orig.changes.hasOwnProperty('newDate') || data.orig.changes.hasOwnProperty('newHour')) {
         this.type === 'moved-to';
         this.absentTeachers = this.teachers.slice();
      }
      */

   }

   onClick(course) {
      
   }

   static getFirstDefinedProperty(props, def) {
      for (const prop of props) {
         if (prop !== undefined) return prop;
      }
      return def;
   }

   belongsTo(course) {

      //if (this.id === 235) console.log(this, course);

      if (this.lessonRef && course.lessonRefs && course.lessonRefs.hasOwnProperty(this.lessonRef)) return true;
      if (this.view.type === 'class') {
         //if (this.affectedTitles.equals(course.titles)) return true;
         if (this.affectedTitles.hasIntersectionWith(course.titles)) return true;
         
      }
      else if (this.view.type === 'pupil') {
         if (this.affectedTitles.hasIntersectionWith(course.titles)) return true;
      }
      else {
         if (this.origClasses.hasIntersectionWith(course.classes)) return true;
      }

      return false;

   }


   render(elCourse, view, dm) {

      elCourse.classList.add('new');
      let rooms = `
         <span class="">${this.removeAbsentItems(this.rooms, this.absentRooms).map(room => dm.getRoom(room).short).join(',')}</span>
         <span class="absent">${this.absentRooms.map(room => dm.getRoom(room).short).join(',')}</span>
      `;

      let teachers = `
         <span class="">${this.removeAbsentItems(this.teachers, this.absentTeachers).join(',')}</span>
         <span class="absent">${this.absentTeachers.join(',')}</span>
      `;

      let titles = `
         <span class="">${this.removeAbsentItems(this.titles, this.absentTitles).join(',')}</span>
         <span class="absent">${this.absentTitles.join(',')}</span>
      `;

      const presentClasses = this.removeAbsentItems(this.classes, this.absentClasses);

      let classes = `
         <span class="">${dm.classGrouper.group(presentClasses).join(',')}</span>
         <span class="absent">${dm.classGrouper.group(this.absentClasses).join(',')}</span>
      `;

      if (this.cancelled) elCourse.classList.add('cancelled');
      
      //console.log(this);


      if (view.type === 'teacher') {
         if (this.absentTeachers.includes(view.id)) elCourse.classList.add('cancelled');
         if (this.absentTeachers.length > 0) titles += ` <span class="absent">(${this.absentTeachers.join(',')})</span>`;
      }

      super.render(this, rooms, teachers, classes, titles, this.message, this.getMovedSymbol(), elCourse, this.weekNumber, view, dm);

      elCourse.onclick = (e) => this.onClick(this);

   }

   getMovedSymbol() {

      if (this.newDate) {
         if      (this.newDate < this.date) return '⭠';
         else if (this.newDate > this.date) return '⭢';
         else {
            if      (this.newHour < this.hour) return '⭡'
            else if (this.newHour > this.hour) return '⭣'
         }
      }
      else if (this.oldDate) {
         if      (this.oldDate > this.date) return '⭰';
         else if (this.oldDate < this.date) return '⭲';
         else {
            if      (this.oldHour > this.hour) return '⭱'
            else if (this.oldHour < this.hour) return '⭳'
         }
      }

      return '';

      //if (moved[9)

      // ⬅ ⮕ ⬆  ⬇

   }

   static setupItem(item, dm) {

      //if (item.affectedTeachers.includes('LO') && item.affectedTeachers.includes('THO')) console.log(item);

      // Gesamtes Item für den alten Vertretungsplan speichern
      const old = JSON.parse(JSON.stringify(item));

      if (old.classes) old.classSortKey = old.classes[0].replace(/^(\d[^\d])/, '0$1');
      else old.classSortKey = '';
      if (old.rooms)   old.roomSortKey = old.rooms[0].replace(/^(\d[^\d])/, '0$1');
      else old.roomSortKey = '';

      // 'new...'-Items in 'changes' verschieben
      for (const prop in item.orig) {
         if (prop.startsWith('new')) {
            item.orig.changes[prop] = item.orig[prop];
            delete item.orig[prop];
         }
      }

      // Wenn ein 'new...' Item in 'changes' vorliegt, wird das entsprechende normale Item zum 'absent...'-Item.
      for (const prop in item.orig.changes) {
         if (prop.startsWith('new')) {
            const baseProp = prop[3].toLowerCase() + prop.slice(4);
            const absentProp = 'absent' + baseProp[0].toUpperCase() + baseProp.slice(1);
            if (item.orig.hasOwnProperty(baseProp) && !item.orig.changes.hasOwnProperty(absentProp)) {
               item.orig.changes[absentProp] = item.orig[baseProp];
            }
         }
      }

      const { titles, absentTitles } = this.setupCourseTitles(item);

      const absentPresence = item.orig.classCodes.length === 1 && !!item.orig.classCodes[0].match(/^P\d$/)
                          && item.orig.changes && item.orig.changes.absentClassCodes && item.orig.changes.absentClassCodes.length === 1
                          && item.orig.changes.absentClassCodes[0] === item.orig.classCodes[0];

      try {
         const setup = {
            old,
            titles,
            absentTitles,
            affectedTitles: titles.concat(absentTitles),
            hour: false,
            span: false,
            affectedTeachers: item.affectedTeachers,
            lessonRef: item.orig.lessonRef,
            date:    this.convertDavinciDate(item.orig.dates[0]),
            newDate: item.orig.changes &&  item.orig.changes.newDate ? this.convertDavinciDate(item.orig.changes.newDate) : false,
            oldDate: item.orig.changes &&  item.orig.changes.oldDate ? this.convertDavinciDate(item.orig.changes.oldDate) : false,
            newHour: item.orig.changes && item.orig.changes.newHour ? parseInt(item.orig.changes.newHour.slice(0,-1)) : false,
            oldHour: item.orig.changes && item.orig.changes.oldHour ? parseInt(item.orig.changes.oldHour.slice(0,-1)) : false,
            message: item.info || '',
            hours:   this.setupHours(item.hour),
            teachers: this.getFirstDefinedProperty([item.orig.changes.newTeacherCodes, item.orig.teacherCodes], []),
            rooms: this.getFirstDefinedProperty([item.orig.changes.newRoomCodes, item.orig.roomCodes], []).map(room => dm.getRoomByName(room).id),
            classes: this.getFirstDefinedProperty([item.orig.changes.newClassCodes, item.orig.classCodes], []).map(item => dm.getClassByName(item).id),
            origClasses: item.orig.classCodes.map(item => dm.getClassByName(item).id),

            absentTeachers: this.getFirstDefinedProperty([item.orig.changes.absentTeacherCodes, item.orig.absentTeacherCodes], []),
            absentRooms: this.getFirstDefinedProperty([item.orig.changes.absentRoomCodes, item.orig.absentRoomCodes], []).map(room => dm.getRoomByName(room).id),
            absentClasses: this.getFirstDefinedProperty([item.orig.changes.absentClassCodes, item.orig.absentClassCodes], []).map(item => dm.getClassByName(item).id),
            cancelled: item.orig.changes.hasOwnProperty('cancelled'),
            absentPresence

         };

         setup.affectedRooms = setup.rooms.concat(setup.absentRooms);
         setup.affectedClasses = setup.classes.concat(setup.classes, setup.origClasses).unique();

         setup.absentRooms = setup.absentRooms.remove(setup.rooms);

         // verschobene Stunde
         if (item.orig.changes.hasOwnProperty('newDate') || item.orig.changes.hasOwnProperty('newHour')) {
            setup.type === 'moved-to';
            setup.absentTeachers = setup.teachers.slice();
         }

         setup.hour = setup.hours[0];
         setup.span = setup.hours.length;

         return setup;

         //Object.assign(item, setup);

      }
      catch(e) {
         console.error(e);
      }



   }

   static setupCourseTitles(data) {

      let titles = null, absentTitles = null;

      if (data.orig.courseTitle) {
         const match = data.orig.courseTitle.match(/^\+(.*) \((.*)\)$/);
         if (match) {
            titles = [match[1]];
            absentTitles = [match[2]];
         }
      }
      
      if (!titles) {
         titles = [data.orig.courseTitle];
         if (data.orig.changes.lessonTitle && data.orig.changes.lessonTitle !== titles[0]) {
            absentTitles = titles;
            titles = [data.orig.changes.lessonTitle];
         }
         else {
            absentTitles = [];
         }
      }

      return { titles, absentTitles };

   }

   static setupHours(hour) {

      const hours = [];
      if (hour) {
         let matches = hour.match(/^(\d+)\.$/);
         if (matches) hours.push(parseInt(matches[1]));
         else {
            matches = hour.match(/^(\d+)\.-(\d+)\.$/)
            if (matches) {
               for (let i = parseInt(matches[1]); i <= parseInt(matches[2]); ++i) {
                  hours.push(i);
               }
            }
         }
      }
      return hours;

   }

   static async setup(substitutions, dm) {

      const newItems = [];

      
      /*
      const o1 = [JSON.parse('{"type":"CANCELLED","date":"2025-09-01","displayDate":"Montag, 01.09","hour":"4.","affectedTeachers":["BEE"],"affectedClasses":["P1"],"teachers":["BEE"],"classes":["P1"],"subject":"P1","changeDate":"20250814095046","affectedClassIds":[1308],"info":"Klasse fehlt","orig":{"lessonRef":"5274AEB0-B16A-4175-9B57-A5E1C660A6AE","courseRef":"59033B0E-7E7D-4FFE-8D40-77E19B135450","dates":["20250901"],"startTime":"1040","endTime":"1125","classCodes":["P1"],"teacherCodes":["BEE"],"changes":{"caption":"Klasse fehlt","changeType":8,"absentClassCodes":["P1"],"reasonType":"classAbsence","modified":"20250814095046"},"hour":"4."}}')];
      const o2 = JSON.parse('{"type":"CANCELLED","date":"2025-09-01","displayDate":"Montag, 01.09","hour":"5.","affectedTeachers":["ENZ"],"affectedClasses":["P3"],"teachers":["ENZ"],"classes":["P3"],"subject":"P3","changeDate":"20250814095059","affectedClassIds":[1310],"info":"Klasse fehlt","absentClasses":["P3"],"orig":{"lessonRef":"5FCBF9A3-5BB7-463F-A810-FD1C6B23B72B","courseRef":"354076DC-8B23-4667-92EC-42BF57ED4EC6","dates":["20250901"],"startTime":"1135","endTime":"1220","classCodes":["P3"],"teacherCodes":["ENZ"],"changes":{"caption":"Klasse fehlt","changeType":8,"absentClassCodes":["P3"],"reasonType":"classAbsence","modified":"20250814095059"},"hour":"5."}}');
      console.log(this.hasSignature(o2, o1));
      */

      const signatures = [];

      try {
         for (const item of substitutions) {
            /*
            if (!this.hasSignature(item.orig, signatures)) {
               signatures.push(JSON.parse(JSON.stringify(item.orig)));
            }
            */

            newItems.push(this.setupItem(item, dm));

         }

         await db.substitutions.clear();
         await db.substitutions.bulkPut(newItems);
         
      }
      catch(e) {      
         toast.alert(e, { duration: 8000 });
         logger.error('Synchronizer.saveSubstitutions: ' + e.message);
      }

   }

   static hasSignature(item, signatures) {

      for (const sig of signatures) {
         if (this.equalSignature(sig, item)) return true;
      };

      return false;

   }

   static equalSignature(o1, o2) {

      if (Object.keys(o1).length !== Object.keys(o2).length) return false;

      for (const prop in o1) {
         if (!o2.hasOwnProperty(prop)) return false;
         if (Object.prototype.toString.call(o1[prop]) === '[object Object]') {
            //if (!Object.prototype.toString.call(o2[prop]) === '[object Object]') return false;
            if (!this.equalSignature(o1[prop], o2[prop])) return false;
         }
      }

      return true;

   }
   


}